export const sigmaOperationalReports = 'fulfillment-reports/overview';
export const sigmaSurchargesReports = 'fulfillment-reports/surcharges';
